module.exports = __webpack_public_path__ + "assets/img/star_sentence_select3.be10c742.png";